export default {
  namespaced: true,
  state: () => ({
    enabled: false,
  }),
  getters: {},
  mutations: {
    enable(state) {
      state.enabled = true;
    },
    disable(state) {
      state.enabled = false;
    },
    set(state, payload) {
      state.enabled = !!payload;
    },
  },
  actions: {},
};
